// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GmfGX","right":"styles_right__CcHKb"};